import { create } from 'zustand'

type PhoneSummary = {
  label: string
  tone: 'green' | 'blue' | 'orange' | 'red' | 'gray'
  active: boolean
  contact: string | null
  action: string | null
}

type PhoneWorkspaceState = {
  open: boolean
  side: 'left' | 'right'
  summary: PhoneSummary
  setOpen: (open: boolean) => void
  openPhone: (side?: 'left' | 'right') => void
  setSummary: (summary: PhoneSummary) => void
}

export const usePhoneWorkspace = create<PhoneWorkspaceState>((set) => ({
  open: false,
  side: 'right',
  summary: { label: 'Offline', tone: 'gray', active: false, contact: null, action: null },
  setOpen: (open) => set({ open }),
  openPhone: (side = 'right') => set({ open: true, side }),
  setSummary: (summary) => set({ summary }),
}))
